import { SET_SAVE_STATE_PENDING } from '../constants/action_types';

const initialState = { pending: false };

export default function (state = initialState, action) {
    switch (action.type) {

        case SET_SAVE_STATE_PENDING:
            return {...state, pending: action.payload}
        default:
            return state
    }
}